import React, { useState } from 'react';
import {
    IconButton, Tooltip, Box, Link, Typography, 
    Checkbox, FormControlLabel, Alert, Paper
} from '@mui/material';
import {Facebook, Twitter, Instagram, Share, Warning} from '@mui/icons-material';

// Replace with your actual URL
const calculatorURL = encodeURIComponent('https://www.rifcalc.com');

export default function Disclaimer() {
    const [termsAccepted, setTermsAccepted] = useState(false);

    return (
        <Paper elevation={3} sx={{
            mt: 2,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            padding: 2
        }}>
            
            <Typography sx={{fontSize: 12, color: '#AAAAAA', textAlign: 'center'}}>
                Disclaimer:
                This website is for entertainment purposes only. It is not official guidance in any way
                and could contain computational errors and should NOT be used for making financial decisions. Don't 
                trust it! In fact I would discourage you from using it to make any decisions because there could be 
                financial consequences. There are too many individual factors involved in making these calculations 
                that can not be accounted for. Don't make life decisions based on this calculator which has a ridiculous 
                meme background. Official guidance only comes from your agency HR department and opm.gov:
            </Typography>
            
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 1 }}>
                <Link
                    href={'https://www.opm.gov/policy-data-oversight/pay-leave/pay-administration/fact-sheets/severance-pay-estimation-worksheet/'}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    OPM Severance Pay Estimation Worksheet
                </Link>
                
                <Link 
                    href="/terms-of-service.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ mt: 1 }}
                >
                    Terms of Service
                </Link>
            </Box>
        </Paper>
    );
}
